/// <reference lib="dom" />
// ^ DOM lib намеренно выключен в tsconfig (@react-native/typescript-config —
//   только ES-библиотеки), чтобы нативный код не дотянулся до `window`. В
//   `.web.ts` эти глобалы реально есть, поэтому файл включает lib сам (как
//   pwa.web.ts / download.web.ts).

// Маршрут по контуру бета/релиз — ВЕБ-сборка (single-domain, модель bookingcore).
//
// Один домен на фронт: `cabinet.sam-vision.uz` (и `admin.sam-vision.uz`). Контур
// выбирает КУКА `sv_contour`, которую читает nginx: по ней он отдаёт данные
// (кабинет — `/api` в контурный гейтвей) и сборку нужного контура. Ставит куку
// этот код ПОСЛЕ входа, прочитав контур из `GET /auth/me`. Нет куки (гость) →
// контур `release` (дефолт nginx).
//
// Раньше здесь был субдомен-редирект (`redirectIfForeignContour`) — модель
// поддоменов `cabinet` / `beta-cabinet`. Single-domain её заменил: с домена
// никого не уводим, только МЕТИМ контур кукой. Кука НЕ секрет — она выбирает
// сборку/бэкенд, а не доступ: контур зашит в токен, и гейтвей чужого контура
// отвечает 401. Подменив куку, человек получит чужую сборку, но не чужие данные.

import {contourCookieAttrs} from '@/shared/lib/contour-cookie';

const CONTOUR_COOKIE = 'sv_contour';

// Родительский домен ТЕКУЩЕГО хоста (см. contour-cookie.ts), чтобы ОДНА кука
// обслуживала и кабинет, и админку, и их `beta-*` поддомены — на обоих доменах
// платформы. `SameSite=Lax` — куку шлём на свой же origin, кросс-site она не
// нужна. НЕ `HttpOnly`: её ставит этот JS (nginx только читает).
function cookieAttrs(): string {
  return contourCookieAttrs(window.location.hostname);
}

/**
 * Метит контур пользователя кукой `sv_contour` (значение из `GET /auth/me`).
 *
 * Вызывать ДО первого запроса данных (`fetchContexts`): `document.cookie`
 * синхронный, и следующий `fetch` уже несёт куку — nginx отдаёт данные нужного
 * контура БЕЗ перезагрузки (сборка кабинета одна на оба контура). Незнакомый или
 * пустой контур → снять куку (дефолт release), чтобы не залипнуть в чужом.
 */
export function setContourCookie(contour?: string | null): void {
  if (typeof document === 'undefined') return;
  if (contour !== 'beta' && contour !== 'release') {
    clearContourCookie();
    return;
  }
  document.cookie = `${CONTOUR_COOKIE}=${contour}; ${cookieAttrs()}`;
}

/**
 * Снимает `sv_contour` (логаут). Следующий вход стартует с release, как гость —
 * иначе на общем компьютере следующий человек унаследовал бы чужой контур.
 */
export function clearContourCookie(): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${CONTOUR_COOKIE}=; ${cookieAttrs()}; Max-Age=0`;
}
